import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FormGroup, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import CONFIG from "../../config";
import axios from "axios";
import "../../Styles/doctorlist.css"
import { usePatient } from "../../context/PatientContext";

const MandalInfoForm = (props) => {
  //  console.log("Initial Values:", props.initialValues);
  const { initialValues, onSubmit } = props;


  const { doctorInfo } = usePatient();
  // const token = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const baseURL = CONFIG.BASE_URL;
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // const initialValues = {
  //   MANDALI_ID: props.initialValues?.MANDALI_ID || "", // Include ID for updates
  //   MANDALI_FULL_NAME: props.initialValues?.MANDALI_FULL_NAME || "",
  //   MANDALI_MOB_NO: props.initialValues?.MANDALI_MOB_NO || "",
  //   MANDALI_PASSWORD: "",
  //   CONFIRM_PASSWORD: "", // Reset password fields
  //   MANDALI_ROLE: props.initialValues?.MANDALI_ROLE || "",
  // };

  const validationSchema = Yup.object().shape({
    MANDALI_FULL_NAME: Yup.string().required("Full name is required"),
    MANDALI_MOB_NO: Yup.string()
      .matches(/^\d{10}$/, "Mobile number must be 10 digits")
      .required("Mobile number is required"),
    MANDALI_PASSWORD: Yup.string()
      .min(8, "Password must be at least 8 characters long")
      .required("Password is required"),
    CONFIRM_PASSWORD: Yup.string()
      .oneOf([Yup.ref("MANDALI_PASSWORD"), null], "Passwords must match")
      .required("Confirm password is required"),
    MANDALI_ROLE: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : Number(value))) // Ensure it's a number
      .required("Role is required")
      .oneOf([1, 2], "Invalid role selected"),
  });

  return (
    <div className="form-wrapper">
      <Formik
        initialValues={{
          ...initialValues,
          MANDALI_PASSWORD: "",
          CONFIRM_PASSWORD: ""
        }}
        validationSchema={validationSchema}
        onSubmit={async (values, actions) => {
          // const { CONFIRM_PASSWORD, ...formData } = values;
          // formData.MANDALI_ROLE = Number(formData.MANDALI_ROLE);
          // formData.CLINIC_ID = props.initialValues?.CLINIC_ID || "";

          // console.log("Submitting Data:", formData);

          // try {
          //   const response = await axios.put(`${baseURL}/doctors/update/${props.initialValues.MANDALI_ID}`, formData, {
          //     headers: {
          //       Authorization: `Bearer ${localStorage.getItem("authToken")}`,        // 🔐 JWT Token
          //       doctorId: doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
          //       clinicId: doctorInfo.CLINIC_ID,
          //       roleId: doctorInfo.MANDALI_ROLE
          //      }
          //   });

          //   console.log("Server Response:", response.data);
          //   alert("Doctor updated successfully!");
          //   navigate("/doctorslist");
          // } catch (error) {
          //   console.error("Error submitting form:", error.response?.data || error.message);
          //   alert("Failed to update doctor.");
          // }
          onSubmit(values); // Pass form values to the parent component's onSubmit function
          actions.setSubmitting(false);
        }}
        enableReinitialize={true}
      >
        {({ errors, touched, isSubmitting }) => (
          <Form>
            <FormGroup>
              <label htmlFor="MANDALI_FULL_NAME">Full Name</label>
              <Field
                name="MANDALI_FULL_NAME"
                type="text"
                disabled={doctorInfo.MANDALI_ROLE !== 1}
                className={`form-control ${touched.MANDALI_FULL_NAME && errors.MANDALI_FULL_NAME ? "is-invalid" : ""
                  }`}
              />
              <ErrorMessage name="MANDALI_FULL_NAME" component="div" className="invalid-feedback" />
            </FormGroup>

            <FormGroup>
              <label htmlFor="MANDALI_MOB_NO">Mobile Number</label>
              <Field
                name="MANDALI_MOB_NO"
                type="text"
                disabled={doctorInfo.MANDALI_ROLE !== 1}
                className={`form-control ${touched.MANDALI_MOB_NO && errors.MANDALI_MOB_NO ? "is-invalid" : ""
                  }`}
              />
              <ErrorMessage name="MANDALI_MOB_NO" component="div" className="invalid-feedback" />
            </FormGroup>

            <FormGroup>
              <label htmlFor="MANDALI_PASSWORD">Password</label>
              <div className="password-field">
                <Field
                  name="MANDALI_PASSWORD"
                  type={showPassword ? "text" : "password"}
                  className={`form-control input-rounded ${touched.MANDALI_PASSWORD && errors.MANDALI_PASSWORD
                      ? "is-invalid"
                      : ""
                    }`}
                />
                <span
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "🙈" : "👁️"}
                </span>
              </div>
              <ErrorMessage
                name="MANDALI_PASSWORD"
                component="div"
                className="invalid-feedback"
              />
            </FormGroup>

            <FormGroup>
              <label htmlFor="CONFIRM_PASSWORD">Confirm Password</label>
              <div className="password-field">
                <Field
                  name="CONFIRM_PASSWORD"
                  type={showConfirmPassword ? "text" : "password"}
                  className={`form-control input-rounded ${touched.CONFIRM_PASSWORD && errors.CONFIRM_PASSWORD
                      ? "is-invalid"
                      : ""
                    }`}
                />
                <span
                  className="toggle-password"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? "🙈" : "👁️"}
                </span>
              </div>
              <ErrorMessage
                name="CONFIRM_PASSWORD"
                component="div"
                className="invalid-feedback"
              />
            </FormGroup>

            <FormGroup>
              <label htmlFor="MANDALI_ROLE">Role</label>
              <Field
                as="select"
                name="MANDALI_ROLE"
                disabled={doctorInfo.MANDALI_ROLE !== 1}
                className={`form-control ${touched.MANDALI_ROLE && errors.MANDALI_ROLE ? "is-invalid" : ""
                  }`}
              >
                <option value="">Select Role</option>
                <option value="1">Admin</option>
                <option value="2">Doctor</option>
              </Field>
              <ErrorMessage name="MANDALI_ROLE" component="div" className="invalid-feedback" />
            </FormGroup>

            <Button type="submit" variant="primary" disabled={isSubmitting}>
              Submit
            </Button>

            <Button
              onClick={() => {
                if (doctorInfo?.MANDALI_ROLE === 1) {
                  navigate("/doctorslist");
                } else {
                  navigate("/getmandaliinfo");
                }
              }}
              type="button"
              variant="danger"
              className="ms-2"
            >
              Cancel
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default MandalInfoForm;
